export function createNoopAdapter() {
  return {
    identify() {},
    track() {},
    reset() {}
  };
}
